/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountWishlistTileViewProps } from './aaa_account-saveddesign-tile';

const AccountWishlistTileView: React.FC<IAccountWishlistTileViewProps> = props => {
    const { AccountWishlistTile, heading, description, links } = props;

    return (
        <Module {...AccountWishlistTile}>
            {heading}
            {description}
            {links}
        </Module>
    );
};

export default AccountWishlistTileView;
